import { combineReducers } from 'redux';


const initialState = {
    galleryItems:undefined,
    galleryCount: 0,
    gal_type:'',
    itemIndex:0,
    galleryCreated : false


};

const galleryData = (state = initialState,  action) => {
    console.log(action.type);
    console.log(action.galleryList);
    switch(action.type){
        case "FETCH_GALLERY_DATA":
            //return action.galleryList.data.response;
            return state
        case "GALLERY_DATA_SUCCESS":
            //return action.galleryList.data.response;
            return {
                ...state,
                galleryItems  : (action.galleryList && action.galleryList.data)? (action.galleryList.data.response) : [],
                galleryCount  : (action.galleryList && action.galleryList.data && action.galleryList.data.response) ? action.galleryList.data.response.length : state.galleryCount,
                galleryCreated : !state.galleryCreated
            }
        case "GALLERY_DATA_FROM_STORE":
            return state.galleryItems
        default:
            return state;
    }
}



const galleryUpdate = (state = initialState,  action) => {
    console.log(action.type);
    console.log(state);
    console.log(action);
    switch(action.type){

        case "SET_TYPE":
            return {
                ...state,
                gal_type  : action.gal_type.type
            }
        case "GET_TYPE":
            return {
                ...state,
                gal_type : state.gal_type
            }
        case "SET_ITEM_ID":
            return {
                ...state,
                itemIndex  : action.gal_item.index
            }
        case "GET_ITEM_ID":
            return {
                ...state,
                itemIndex : state.itemIndex?state.itemIndex:0
            }
        case "SAVE_GALLERY":
            return {
                ...state,
                galleryCreated  : !state.galleryCreated
            }
        case "DOWNLOAD_FILE":
            return {
                ...state,
                fileContent : (action.downloaded && action.downloaded.data)? (action.downloaded.data.response) : state.fileContent,
            }
        default:
            return state;
    }
}


const gallery = combineReducers({
    galleryData,
    galleryUpdate
})

export default gallery;
export const getGalleryData = state => state.gallery.galleryData;

export const setGalleryUpdate = state => state.gallery.galleryUpdate;
//export const getGalleryDetails = state => state.gallery.galleryDetails;


// WEBPACK FOOTER //
// ./src/reducers/gallery.js